export default __webpack_public_path__ + "1744004e8a3d785f057e26de95cba999.png";